export class CopyFromDates {
  periodStartDate: string;
  periodEndDate: string;
  strDate: string
}
